import {
	getAddressCheckoutData,
	getCheckoutData,
	getOrderCheckoutData,
	postCheckout,
	putCheckout
} from "../../api/checkoutController";
import { cloneDeep } from "lodash";
import Cookies from "js-cookie";
import { storageKeys } from "../../api/storageKeys";

export const fetchAddressCheckoutData = async ({
	setAddressCheckoutInfo,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let checkoutUser = await getAddressCheckoutData();
		if (checkoutUser?.success) {
			const addressData = checkoutUser.data;
			const addressDataClone = cloneDeep(addressData);

			const newShippingAddress = Cookies.get(
				storageKeys.NEW_CHECKOUT_SHIPPING_ADDRESS
			);
			if (newShippingAddress) {
				const guestTempuserAddresses = [];
				guestTempuserAddresses.push(JSON.parse(newShippingAddress));
				addressDataClone.userAddresses = guestTempuserAddresses;
			}

			setAddressCheckoutInfo(addressDataClone);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchOrderCheckoutData = async ({
	setOrderCheckoutInfo,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let checkoutUser = await getOrderCheckoutData();
		if (checkoutUser?.success) {
			setOrderCheckoutInfo(checkoutUser.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchCheckoutData = async ({
	setCheckoutData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let checkoutData = await getCheckoutData();
		if (checkoutData?.success) {
			setCheckoutData(checkoutData.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const updateCheckoutData = async ({
	checkoutData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await putCheckout(checkoutData);

		if (response.success) {
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (e) {
		console.error(e);
		setStatusError();
	}
};

export const createCheckout = async ({
	items,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await postCheckout(items);
		if (response.success) {
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};
